import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}
type CountdownProps = {
  size?: 'sm' | 'md';
};
export function Countdown({
  size = 'md'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS - 1);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 0 ? TOTAL_SECONDS - 1 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hrs = Math.floor(remaining / 3600);
  const min = Math.floor(remaining % 3600 / 60);
  const sec = remaining % 60;
  const cell = size === 'sm' ? 'text-2xl px-2.5 py-1' : 'text-3xl sm:text-4xl px-3 py-1.5';
  const parts: Array<[string, string]> = [[pad(hrs), 'HRS'], [pad(min), 'MIN'], [pad(sec), 'SEC']];
  return <div className="flex flex-col items-center gap-1.5" data-id="element-18" data-mp="15bg1k5q6qv42">
      <p className="font-display text-[11px] sm:text-xs font-bold tracking-[0.22em] text-mute" data-id="element-19" data-mp="15awiumspo2oz">
        L’OFFERTA TERMINA TRA
      </p>
      <div className="flex items-center gap-1.5" role="timer" aria-live="off" aria-label={`Offerta termina tra ${pad(hrs)} ore ${pad(min)} minuti ${pad(sec)} secondi`} data-id="element-20" data-mp="xytv6aq2kr33">
        {parts.map(([value, label], i) => <React.Fragment key={label} data-id="element-21" data-mp="12t7u2n3xxgci" data-mpi={i}>
            {i > 0 && <span className="font-display text-2xl text-forge/70 pb-1" data-id="element-22" data-mp="f1sn2h17yaux">:</span>}
            <span className="flex flex-col items-center" data-id="element-23" data-mp="a3hee9mnu6ea">
              <span className={`font-display font-bold tabular-nums leading-none text-bone bg-ink-700 border border-ink-500 rounded-md ${cell}`} data-id="element-24" data-mp="a5267rhlbb8g">
                {value}
              </span>
              <span className="mt-1 text-[9px] font-semibold tracking-[0.18em] text-mute" data-id="element-25" data-mp="k3rovmhb8zpr">
                {label}
              </span>
            </span>
          </React.Fragment>)}
      </div>
    </div>;
}